
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GeoJSON from 'ol/format/GeoJSON';

import {
    INPUT_TYPE_DRAW,
    INPUT_TYPE_FILE,
    getLoading,
    getInputType,
    getReadFileResult,
    getUsekMezItems,
} from '../../reducers/project';

import projectGetActions from '../../sagas/project';

import { PAGE_USEK_ATTRS, redirectToPage } from '../pagesDefinition';
import Map from './Map.state';
import SelectInputType from './SelectInputType.state';
import SelectFileForImport from './SelectFileForImport.state';
import UsekInputPageView from './UsekInputPage.view';
import UsekListDetail from './UsekListDetail.state';

const UsekInputPageState = (props) => {

    const dispatch = useDispatch();
    const projectActions = projectGetActions(dispatch);

    const inputType = useSelector(state => getInputType(state.project));
    const readFileResult = useSelector(state => getReadFileResult(state.project));
    const loading = useSelector(state => getLoading(state.project));
    const usekMezItems = useSelector(state => getUsekMezItems(state.project));

    const isMapVisible = ((usekMezItems) || (inputType === INPUT_TYPE_DRAW));

    React.useEffect(() => {
        if (readFileResult && readFileResult.items.length > 0) {
            projectActions.useReadedItems();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [readFileResult]);

    const getCanContinue = () => {
        const usekCount = usekMezItems ? usekMezItems.length : 0;
        return (usekCount > 0);
    }

    const handleContinueClick = () => {
        if (usekMezItems && usekMezItems.length > 0) {
            usekMezItems.forEach(item => {
                let geometry = (new GeoJSON()).readGeometry(item.geometry);
                projectActions.setUsekAttribute(
                    item.properties.id_usek, 'delka', Math.round(geometry.getLength())
                );
            });
        }
        saveMapContent();
        redirectToPage(PAGE_USEK_ATTRS);
    }

    const handleSetInputType = (inputType) => {
        projectActions.setInputType(inputType);
    }

    const handleUploadFile = (file) => {
        let reader = new FileReader();
        reader.onload = () => {
            let dataURL = reader.result;
            projectActions.readFile(dataURL, file.name);
        };
        reader.readAsDataURL(file);
    }

    const handleUseReadedItems = () => {
        projectActions.useReadedItems();
    }

    const renderMap = () => {
        return isMapVisible
            ? <Map />
            : null;
    }

    const renderSelectInputType = () => {
        return (
            <SelectInputType
                inputType={inputType}
                onSetInputType={handleSetInputType}
                readedFromFile={(readFileResult && readFileResult.items.length > 0)}
            />
        );
    }

    const renderSelectFileForImport = () => {
        switch (inputType) {
            case INPUT_TYPE_FILE:
                return (
                    <SelectFileForImport
                        loading={loading}
                        readFileResult={readFileResult}
                        onUploadFile={handleUploadFile}
                        onUseReadedItems={handleUseReadedItems}
                    />
                );
            default:
                return null;
        }
    }

    const renderUsekDetail = () => {
        return isMapVisible
            ? (
                <UsekListDetail
                    onContinueClick={handleContinueClick}
                    usekMezItems={usekMezItems}
                />
            )
            : null;
    }

    const saveMapContent = () => {
        let content = null;
        let nodes = document.querySelectorAll('.ol-layer canvas');
        if (nodes.length > 0) {
            let canvas = nodes[0];
            const { width, height } = canvas.getBoundingClientRect();
            content = {
                width,
                height,
                content: canvas.toDataURL()
            };
            projectActions.setMapContent(content);
        }
    }

    return (
        <UsekInputPageView
            canContinue={getCanContinue()}
            map={renderMap()}
            onContinueClick={handleContinueClick}
            selectInputType={renderSelectInputType()}
            selectFileForImport={renderSelectFileForImport()}
            usekDetail={renderUsekDetail()}
        />
    );
}

export default UsekInputPageState;
